import React, { useRef, useEffect } from "react";
import {
  Typography,
  Box,
  Container,
  Breadcrumbs,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  useMediaQuery,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import { FiberManualRecord } from "@mui/icons-material";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { NavigateNext } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import PageHeaderWithBreadcrumbs from "../components/common/PageHeaderWithBreadcrumbs";
import Space from "../components/common/Space";
import NumberedList from "../components/common/NumberedList.js";

const ApplyForAnEtail1 = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const contentRef = useRef(null);

  useEffect(() => {
    // if (contentRef.current) {
    //   const stickyHeader = document.querySelector("[data-sticky-header]");
    //   const headerHeight = stickyHeader ? stickyHeader.offsetHeight : 0;
    //   const elementTop = contentRef.current.offsetTop;
    //   const padding = 120;
    //   window.scrollTo({
    //     top: elementTop - headerHeight - padding,
    //     behavior: "smooth",
    //   });
    // }
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const listSteps = [
    t("applyForAnEtail1.steps.listSteps.item1"),
    t("applyForAnEtail1.steps.listSteps.item2"),
    t("applyForAnEtail1.steps.listSteps.item3"),
    t("applyForAnEtail1.steps.listSteps.item4"),
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        background: "#E8EDF6",
        py: { xs: 2, md: 0 },
      }}
    >
      <PageHeaderWithBreadcrumbs
        breadcrumbs={[
          { text: t("applyForAnEtail1.breadcrumbs.home"), href: "/" },
          { text: t("applyForAnEtail1.breadcrumbs.application") },
        ]}
        title={t("applyForAnEtail1.header.title")}
        subtitle={t("applyForAnEtail1.header.subtitle")}
        applyButtonText={false}
        sticky={false}
      />
      <Container maxWidth="lg">
        {/* Bloc principal */}
        <Box
          sx={{
            background: "#fff",
            borderRadius: 1,
            boxShadow: "0 2px 16px rgba(24,59,86,0.07)",
            px: { xs: 2, sm: 2, md: 6 },
            py: { xs: 2, sm: 3, md: 5 },
            mb: 5,
          }}
        >
          <Typography
            variant="h3"
            component="h2"
            sx={{ fontWeight: 600, color: "#183B56", mb: 2 }}
          >
            {t("applyForAnEtail1.steps.title")}
          </Typography>
          <Typography
            variant="h6"
            component="h3"
            sx={{ fontWeight: 400, color: "#183B56", mb: 4 }}
          >
            {t("applyForAnEtail1.header.subtitle")}
          </Typography>
          <Typography
            variant="body1"
            component="h4"
            sx={{ color: "#183B56", mb: 0 }}
          >
            {t("applyForAnEtail1.steps.listSteps.title")}
          </Typography>

          <NumberedList
            // title={t("applyForAnEtail1.steps.listSteps.title")}
            items={listSteps}
          />
          <Typography
            variant="body1"
            component="p"
            sx={{ color: "#183B56", mb: 0 }}
          >
            {t("applyForAnEtail1.steps.note")}
          </Typography>
          <Typography
            variant="body1"
            component="p"
            sx={{ color: "#183B56", mb: 0 }}
          >
            {t("applyForAnEtail1.steps.note2")}
          </Typography>
          <Typography
            variant="body1"
            component="p"
            sx={{ color: "#183B56", mb: 4 }}
          >
            {t("applyForAnEtail1.steps.note3")}
          </Typography>
          <Button variant="primary" type="link" sx={{ mt: 2 }} onClick={() => navigate("/apply-for-an-eta-il-2")}>
            {t("applyForAnEtail1.steps.button")}
          </Button>
        </Box>
      </Container>
      <Space size="small" />
    </Box>
  );
};

export default ApplyForAnEtail1;
